
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AccountModule, MetricsModule } from "@/store/modules";
import MetricsChart from "./MetricsChart.vue";

interface DefaultMetric {
  lastBusinessDayMetric: number;
  lastBusinessDayTotal: number;
  monthToDateMetric: number;
  monthToDateTotal: number;
  type: string;
  weekToDateMetric: number;
  weekToDateTotal: number;
}

const metricsModule = getModule(MetricsModule);
const accountModule = getModule(AccountModule);

@Component({
  components: {
    MetricsChart
  }
})
export default class Metrics extends Vue {
  metrics: Array<DefaultMetric> = null;
  typeOptions: Array<string> = ["Manual Scanning", "On Time", "Scanning Compliance"];

  async mounted() {
    this.loadMetrics();
  }

  get isLoading() {
    return metricsModule.isLoading;
  }

  set isLoading(newVal) {
    metricsModule.setLoading(newVal);
  }

  get facilityFilter() {
    return accountModule.homeFacilitiesUserSettings;
  }

  get types() {
    return metricsModule.types;
  }

  set types(newVal) {
    metricsModule.setTypes(newVal);
  }

  @Watch("types")
  typesChanged() {
    this.isLoading = true;
    this.loadMetrics().then(() => {
      this.isLoading = false;
    });
  }

  @Watch("facilityFilter")
  facilitiesChanged() {
    this.isLoading = true;
    this.loadMetrics().then(() => {
      this.isLoading = false;
    });
  }

  async loadMetrics() {
    await metricsModule
      .getByFacilityAndType()
      .then(response => {
        this.metrics = response.data;
      })
      .catch(err => console.warn(err))
      .finally(() => {
        this.isLoading = false;
      });
  }
}
